// Handles serer side calling of vvarious hooks
// updates things like actions

import { app, scriptService } from "Js/feathers";
import { actions } from "Js/actionsProcessor";
import store from "Js/store";

// Wraps callService with handlers
const runHook = function(payload, hookName) {
  // console.log('store: ', this.store.state.auth.user)
  // payload.user = this.store.state.auth.user
  callService(payload, "formsService.onDataFetch").then(result => {
    console.log("@hookHandler", result);
    // // Push all actions
    // actions.queue(result.actions)

    return result;
  });
};

// Calls raw service
const callService = function(payload, service) {
  return new Promise((resolve, reject) => {
    // console.log('@hookHandler callService')
    scriptService
      .create({
        service: service,
        data: payload
      })
      .then(result => {
        // alert call errors
        resolve(result);
      })
      .catch(function(err) {
        reject(err);
      });
  });
};

export { runHook };
